import type { HelpFile } from '../../types/help'
import { ProvisioningTasksTestIds } from '../../../testids/ProvisioningTasksTestIds'

export const provisioningTasksHelp: HelpFile = {
  docPage: '/docs/provisioning/provisioning-tasks',
  texts: {
    [ProvisioningTasksTestIds.provisioningTasksList]: 'Einzelne Bereitstellungsoperationen in der Warteschlange — eine Zeile pro Enforcement-Objekt-Änderung für eine Identität auf einem Zielsystem.',
    [ProvisioningTasksTestIds.colAccount]: 'Konto im Zielsystem, das durch diese Aufgabe geändert wird.',
    [ProvisioningTasksTestIds.btnRefresh]: null,
    [ProvisioningTasksTestIds.checkSelectAll]: 'Wählt alle fehlgeschlagenen Aufgaben auf dieser Seite für die Massenwiederholung aus. Nicht fehlgeschlagene Zeilen bleiben unausgewählt.',
    [ProvisioningTasksTestIds.btnBulkRetry]: 'Wiederholt jede ausgewählte fehlgeschlagene Aufgabe. Öffnet einen Bestätigungsdialog mit Anzahl und aktivem Zielsystem-Filter.',
    [ProvisioningTasksTestIds.bulkRetryDialogTitle]: null,
  },
}
